import { render } from "./VsudCheckbox.vue?vue&type=template&id=ddb6ffd0&scoped=true"
import script from "./VsudCheckbox.vue?vue&type=script&lang=js"
export * from "./VsudCheckbox.vue?vue&type=script&lang=js"

import "./VsudCheckbox.vue?vue&type=style&index=0&id=ddb6ffd0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddb6ffd0"]])

export default __exports__